import { render, staticRenderFns } from "./ColumnSelector.vue?vue&type=template&id=dfdd9466&scoped=true"
import script from "./ColumnSelector.vue?vue&type=script&lang=js"
export * from "./ColumnSelector.vue?vue&type=script&lang=js"
import style0 from "./ColumnSelector.vue?vue&type=style&index=0&id=dfdd9466&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../Users/wencesszelagowski/Downloads/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfdd9466",
  null
  
)

export default component.exports